<template>
  <div>
    <v-container>
      <!-- <v-btn @click="test()">test</v-btn>
      <v-btn @click="test1()"></v-btn> -->
      <generalAlert
        v-if="alert"
        :alert="alert"
        :alertType="alertType"
        :message="successResponse"
      />
      <v-row>
        <v-col
          v-if="
            this.$store.state.user.userType == 'AA' && this.packageType != 'Compeat Demo Subscription' ||
            this.$store.state.user.userType == 'SMM' && this.packageType != 'Compeat Demo Subscription'
          "
          cols="1"
          sm="1"
          md="1"
        >
          <v-btn @click="backToAgencySubscriptions()" color="primary" icon>
            <v-icon>mdi-arrow-left-bold-circle</v-icon>
          </v-btn>
        </v-col>
        <v-col
          v-if="
            this.$store.state.user.userType == 'AA' && this.packageType == 'Compeat Demo Subscription' ||
            this.$store.state.user.userType == 'SMM' && this.packageType == 'Compeat Demo Subscription'
          "
          cols="1"
          sm="1"
          md="1"
        >
          <v-btn @click="backToAgencyDemoSubscriptions()" color="primary" icon>
            <v-icon>mdi-arrow-left-bold-circle</v-icon>
          </v-btn>
        </v-col>
        <v-col
          v-if="this.$store.state.user.userType == 'RS'"
          cols="1"
          sm="1"
          md="1"
        >
          <v-btn @click="backToResellerSubscriptions()" color="primary" icon>
            <v-icon>mdi-arrow-left-bold-circle</v-icon>
          </v-btn>
        </v-col>
        <v-col
          v-if="this.$store.state.user.userType == 'SB'"
          cols="1"
          sm="1"
          md="1"
        >
          <v-btn @click="backToClientSubscriptions()" color="primary" icon>
            <v-icon>mdi-arrow-left-bold-circle</v-icon>
          </v-btn>
        </v-col>
        <v-col
          v-if="this.$store.state.user.userType == 'SA'"
          cols="1"
          sm="1"
          md="1"
        >
          <v-btn @click="backToSubscriptions()" color="primary" icon>
            <v-icon>mdi-arrow-left-bold-circle</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="7" sm="7" md="7" lg="7">
          <h2>Subscription</h2>
        </v-col>
        <!-- <v-col cols="1">

        </v-col> -->
        <v-col
          v-if="
            this.paypalSubscriptionDataStatus == 'APPROVAL_PENDING'
          "
          class="text-right hidden-sm-and-down"
          cols="2">
         <v-btn class="green white--text" small rounded @click="approvePayment()"><v-icon>  mdi-pause-circle </v-icon> Approve</v-btn>
        </v-col>
        <v-col
          v-if="
            this.$store.state.agency.agencyType == 'CompEatPaid' && this.paypalSubscriptionDataStatus != 'APPROVAL_PENDING' ||
            (this.$store.state.user.userType == 'AA' &&
              this.$store.state.agency.agencyName == 'Compeat.social' &&
              this.subscriptionPackage != 'Package 3') ||
            (this.$store.state.user.userType == 'SMM' &&
              this.$store.state.agency.agencyName == 'Compeat.social' &&
              this.subscriptionPackage != 'Package 3') ||
            (this.$store.state.user.userType == 'AA' &&
              this.$store.state.agency.agencyName ==
                'Right Click Media Digital Solutions' &&
              this.subscriptionPackage != 'Package 3') ||
            (this.$store.state.user.userType == 'SMM' &&
              this.$store.state.agency.agencyName ==
                'Right Click Media Digital Solutions' &&
              this.subscriptionPackage != 'Package 3') ||
            (this.$store.state.user.userType == 'RS' &&
              this.$store.state.agency.agencyName == 'Compeat.social')
          "
          class="text-center px-0 hidden-sm-and-down  ml-auto"
          cols="1"
        >
          <pauseSubscription
            :packageType="this.packageType"
            :subscription="this.selectedSubscription"
            @successAlert="pauseSubscription"
          />
        </v-col>
        <v-col
          v-if="
            this.$store.state.agency.agencyType == 'CompEatPaid' ||
            (this.$store.state.user.userType == 'AA' &&
              this.$store.state.agency.agencyName == 'Compeat.social' &&
              this.subscriptionPackage != 'Package 3') ||
            (this.$store.state.user.userType == 'SMM' &&
              this.$store.state.agency.agencyName == 'Compeat.social' &&
              this.subscriptionPackage != 'Package 3') ||
            (this.$store.state.user.userType == 'AA' &&
              this.$store.state.agency.agencyName ==
                'Right Click Media Digital Solutions' &&
              this.subscriptionPackage != 'Package 3') ||
            (this.$store.state.user.userType == 'SMM' &&
              this.$store.state.agency.agencyName ==
                'Right Click Media Digital Solutions' &&
              this.subscriptionPackage != 'Package 3') ||
            (this.$store.state.user.userType == 'RS' &&
              this.$store.state.agency.agencyName == 'Compeat.social')
          "
          class="text-center px-0 hidden-sm-and-down"
          cols="1"
        >
          <cancelSubscription
            :subscription="this.selectedSubscription"
            @successAlert="cancelledSubscription"
          />
        </v-col>
        <v-col
          class="text-center hidden-md-and-up"
          cols="1"
        >
          <testEditPackage
          v-if="
            (this.$store.state.user.userType == 'SA' &&
              this.$store.state.agency.agencyType == 'CompEatPaid') ||
            (this.$store.state.user.userType == 'AA' &&
              this.$store.state.agency.agencyName == 'Compeat.social' &&
              this.subscriptionPackage != 'Package 3' && this.subscriptionPackage != 'Package 2') ||
            (this.$store.state.user.userType == 'SMM' &&
              this.$store.state.agency.agencyName == 'Compeat.social' &&
              this.subscriptionPackage != 'Package 3' && this.subscriptionPackage != 'Package 2') ||
              (this.$store.state.user.userType == 'SB' &&
              this.$store.state.agency.agencyName == 'Compeat.social' &&
              this.subscriptionPackage != 'Package 3' && this.subscriptionPackage != 'Package 2' && this.subscriptionPages.length < 5) ||
            (this.$store.state.user.userType == 'AA' &&
              this.$store.state.agency.agencyName ==
                'Right Click Media Digital Solutions' &&
              this.subscriptionPackage != 'Package 3' && this.subscriptionPackage != 'Package 2') ||
            (this.$store.state.user.userType == 'SMM' &&
              this.$store.state.agency.agencyName ==
                'Right Click Media Digital Solutions' &&
              this.subscriptionPackage != 'Package 3' && this.subscriptionPackage != 'Package 2')
          "
            @successAlert="successAlert"
            :subscription="this.selectedSubscription"
            :subscriptionPages="this.subscriptionPages"
            :subscriptionPackage="this.subscriptionPackage"
          />
        </v-col>
        <v-col
          v-if="
            this.$store.state.agency.agencyType == 'CompEatPaid' ||
            (this.$store.state.user.userType == 'AA' &&
              this.$store.state.agency.agencyName == 'Compeat.social' &&
              this.subscriptionPackage != 'Package 3') ||
            (this.$store.state.user.userType == 'SMM' &&
              this.$store.state.agency.agencyName == 'Compeat.social' &&
              this.subscriptionPackage != 'Package 3') ||
            (this.$store.state.user.userType == 'AA' &&
              this.$store.state.agency.agencyName ==
                'Right Click Media Digital Solutions' &&
              this.subscriptionPackage != 'Package 3') ||
            (this.$store.state.user.userType == 'SMM' &&
              this.$store.state.agency.agencyName ==
                'Right Click Media Digital Solutions' &&
              this.subscriptionPackage != 'Package 3')
          "
          class="text-center hidden-md-and-up"
          cols="1"
        >
          <pauseSubscription
            :subscription="this.selectedSubscription"
            @successAlert="pauseSubscription"
          />
        </v-col>
        <v-col
          v-if="
            this.$store.state.agency.agencyType == 'CompEatPaid' ||
            (this.$store.state.user.userType == 'AA' &&
              this.$store.state.agency.agencyName == 'Compeat.social' &&
              this.subscriptionPackage != 'Package 3') ||
            (this.$store.state.user.userType == 'SMM' &&
              this.$store.state.agency.agencyName == 'Compeat.social' &&
              this.subscriptionPackage != 'Package 3') ||
            (this.$store.state.user.userType == 'AA' &&
              this.$store.state.agency.agencyName ==
                'Right Click Media Digital Solutions' &&
              this.subscriptionPackage != 'Package 3') ||
            (this.$store.state.user.userType == 'SMM' &&
              this.$store.state.agency.agencyName ==
                'Right Click Media Digital Solutions' &&
              this.subscriptionPackage != 'Package 3')
          "
          class="text-center hidden-md-and-up"
          cols="1"
        >
          
          <cancelSubscription
            :subscription="this.selectedSubscription"
            @successAlert="cancelledSubscription"
          />
        </v-col>
        <v-col cols="12">
          <v-card class="px-4 py-4 mb-4">
            <v-row justify="center" align="center">
              <v-col cols="2" sm="2" md="1">
                <v-avatar>
                  <img lazy-src="../assets/defaultimage.jpeg" :src="subscriptionIcon" />
                </v-avatar>
              </v-col>
              <v-col cols="10" sm="10" md="8" lg="8">
                Primary Page: {{ this.subscriptionPrimaryPage }}
              </v-col>
              <v-col cols="2" class="text-right hidden-sm-and-down">
                <h3 v-if="packageType == 'Compeat Demo Subscription'">{{ subscriptionDateCreated | daysFromNow }} Days Left</h3>
              </v-col>
              <v-col cols="12" class="text-center hidden-sm-and-up">
                <h3 v-if="packageType == 'Compeat Demo Subscription'">{{ subscriptionDateCreated | daysFromNow }} Days Left</h3>
              </v-col>
               <v-col
               v-if="
               subscriptionPackage == 'Package 3' && packageType != 'Compeat Demo Subscription' && this.subscriptionPages.length < 5 || 
               subscriptionPackage == 'Package 1' && packageType != 'Compeat Demo Subscription' && this.subscriptionPages.length < 5 || 
               this.$store.state.user.userType == 'AA' && packageType == 'Compeat Demo Subscription' && subscriptionPackage != 'Package 2' || 
               this.$store.state.user.userType == 'SMM' && packageType == 'Compeat Demo Subscription' && subscriptionPackage != 'Package 2'"
                class="text-center px-0 hidden-sm-and-down"
                cols="1"
              >
                <testEditPackage
                  @successAlert="successAlert"
                  :subscription="this.selectedSubscription"
                  :subscriptionPages="this.subscriptionPages"
                  :subscriptionPackage="this.subscriptionPackage"
                />
              </v-col>
              <v-col class="py-0" cols="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <h4>Account Holder</h4>
                <p class="mb-0">Name: {{ this.selectedSubscription.name }}</p>
                <p class="mb-0">Email: {{ this.selectedSubscription.email }}</p>
                <p class="mb-0">
                  Mobile: {{ this.selectedSubscription.mobile }}
                </p>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <h4>Package Info</h4>
                <p class="mb-0">Package: {{ this.subscriptionPackage }}</p>
                <p class="mb-0">
                  Date Created:
                  {{ this.subscriptionDateCreated | formatDate }}
                </p>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card>
            <v-tabs
              class="tabsbackground"
              fixed-tabs
              v-model="tab"
              height="80px"
            >
              <v-tab
                style="font-size: 12px"
                v-for="item in items"
                :key="item.tab"
                :disabled="isBillingTabDisabled(item)"
              >
                <h3>{{ item.tab }}</h3>
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item>
                <div class="text-center">
                  <p class="mt-4 mb-0">
                    Each month, a new report will be included in this list, and
                    you can access the report by clicking on the eye icon.
                  </p>
                  <v-row style="padding: 20px" justify="center">
                    <v-col cols="12">
                      <v-data-table
                        :headers="headers"
                        :items="reportSets"
                        :items-per-page="5"
                        :loading="overlay"
                        loading-text="Loading... Please wait"
                      >
                        <template v-slot:[`item.date`]="{ item }">
                          {{ item.date }}
                        </template>
                        <template
                          v-slot:[`item.competitiveReportId`]="{ item }"
                        >
                          <v-btn

                            v-if="item.competitiveReportId"
                            icon
                            @click="
                              viewReport(item.competitiveReportId.reportId)
                            "
                            color="primary"
                            ><v-icon>mdi-eye</v-icon>
                          </v-btn>
                          <p v-else class="mb-0">N/A</p>
                        </template>
                        <template v-slot:[`item.insightsReportId`]="{ item }">
                          <v-btn

                            v-if="item.insightsReportId"
                            @click="
                              viewInsightsReport(item.insightsReportId.reportId)
                            "
                            icon
                            color="primary"
                            ><v-icon>mdi-eye</v-icon></v-btn
                          >
                          <p v-else class="mb-0 checkaccessbutton">N/A</p>
                        </template>
                        <template v-slot:[`item.instagramReportId`]="{ item }">
                          <v-btn

                            v-if="item.instagramReportId"
                            @click="
                              viewInstagramInsightsReport(
                                item.instagramReportId.reportId
                              )
                            "
                            icon
                            color="primary"
                            ><v-icon>mdi-eye</v-icon></v-btn
                          >
                          <p v-else class="mb-0">N/A</p>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </div>
              </v-tab-item>
              <v-tab-item>
                <div class="text-center">
                  <v-row style="padding: 20px" justify="center">
                    <!-- <v-col cols="12" class="text-center">
                    </v-col> -->
                    <v-col cols="12" sm="12" md="6" lg="6">
                      <v-row>
                        <v-col cols="12" class="py-0 text-left">
                          <h4 v-if="paypalSubscriptionDataStatus == 'ACTIVE'">Status: <v-chip small color="success">{{ paypalSubscriptionDataStatus }}</v-chip></h4>
                          <h4 v-else>Status: <v-chip small color="error">{{ paypalSubscriptionDataStatus }}</v-chip></h4>
                          <h3 v-if="paypalBillingInfo.next_billing_time">Next Billing Date: {{ paypalBillingInfo.next_billing_time | formatDate }}</h3>
                          <h3 v-if="paypalBillingInfo.last_payment">Last Payment Date: {{ paypalBillingInfo.last_payment.time | formatDate }}</h3>
                          <p>Failed Payments: {{ paypalBillingInfo.failed_payments_count }}</p>
                          <v-alert
                              v-if="paypalBillingInfo.failed_payments_count == 1"
                              dense
                              outlined
                              type="error"
                            >
                            <strong>Out Standing Amount:{{ paypalBillingInfo.last_payment.amount.currency_code }} {{ paypalBillingInfo.last_payment.amount.value | formatNumber }}!</strong>
                            </v-alert>
                          <!-- <p v-if="paypalBillingInfo.failed_payments_count == 1">Out Standing Amount: {{ paypalBillingInfo.last_payment.amount.value }}</p> -->
                        </v-col>
                        <v-col cols="12" class="py-0"v-for="item in paypalBillingInfo.cycle_executions"
                              :key="item.id">
                              <!-- v-if="item.tenure_type == 'TRIAL' && item.cycles_remaining == 1 || item.tenure_type == 'REGULAR'" -->
                            <v-card
                              
                              class="my-2"
                              >
                              <v-card-text class="py-3 px-0">
                                <v-row>
                                  <v-col cols="4" :class="billingCycleClass(item.tenure_type)">
                                    <h3 class="white--text pt-1">{{item.tenure_type}}</h3>
                                  </v-col>
                                  <v-col cols="8">
                                    <h3 v-if="item.tenure_type == 'TRIAL'">{{ daysLeft }} Days Left</h3>
                                    <h3 v-if="item.tenure_type == 'REGULAR' && paypalBillingInfo.next_billing_time">Next - {{paypalBillingInfo.next_billing_time | formatDate}}</h3>
                                    <h3 v-if="item.tenure_type == 'REGULAR' && paypalBillingInfo.last_payment">Last - {{paypalBillingInfo.last_payment.time | formatDate}}</h3>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                              </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="12" md="6" lg="6">
                      <v-row>
                        <v-col cols="12" class="py-0">
                          <h2>Billing Address</h2>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <v-text-field 
                            label='Street Address'
                            v-model="paypalSubscriberAddress.address_line_1"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <v-text-field 
                            label='Area'
                            v-model="paypalSubscriberAddress.address_line_2"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <v-text-field 
                            label='City/Town'
                            v-model="paypalSubscriberAddress.admin_area_1"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <v-text-field 
                            label='City/Town'
                            v-model="paypalSubscriberAddress.admin_area_2"
                          >
                          </v-text-field>
                        </v-col>
                        <!-- <v-col cols="12">
                          <v-btn
                            rounded
                            color="primary"
                            small
                          >
                            Update
                          </v-btn>
                        </v-col> -->
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="120"
        >Please Wait...</v-progress-circular
      >
    </v-overlay>
  </div>
</template>

<script>
import testEditPackage from "../components/dialogs/testEditPackage.vue";
import generalAlert from "../components/alerts/generalAlert.vue";
import cancelSubscription from "../components/dialogs/cancelSubscription.vue";
import pauseSubscription from "../components/dialogs/pauseSubscription.vue";
import checkForPageAccess from "../components/dialogs/checkAccess.vue";
import { firebaseApp } from "../firebaseConfig";
import {
  getFirestore,
  doc,
  getDoc,
  getDocs,
  collection,
  where,
  query
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
const db = getFirestore(firebaseApp);
import moment from "moment-timezone";

export default {
  components: {
    testEditPackage,
    generalAlert,
    cancelSubscription,
    pauseSubscription,
    checkForPageAccess,
  },
  props: ["id", "uid"],
  data: () => ({
    selectedSubscription: [],
    clientsDetailsFromDemo:[],
    subscriptionIcon: "https://danetopham.co.za/images/defaultImg2.jpg",
    subscriptionPrimaryPage: "",
    subscriptionPackage: [],
    subscriptionPages: [],
    subscriptionDateCreated: "",
    freeSubscription:false,
    packageType: "",
    reports: [],
    insightsReports: [],
    reportSets: [],
    overlay: false,
    tab: null,
    items: [
      { tab: "Client Reports", content: "Tab 1 Content" },
      { tab: "Billing Details", content: "Tab 2 Content" },
    ],
    pages: [],
    superAdminUser: false,
    agencyAdminUser: false,
    subscriberUser: false,
    successResponse: "",
    alertType: "",
    alert: false,
    headers: [
      {
        text: "Date",
        sortable: false,
        value: "date",
        align: "center",
      },
      {
        text: "Competitive Report",
        sortable: false,
        value: "competitiveReportId",
        align: "center",
      },
      {
        text: "Facebook Insights",
        sortable: false,
        value: "insightsReportId",
        align: "center",
      },
      {
        text: "Instagram Insights",
        sortable: false,
        value: "instagramReportId",
        align: "center",
      },
    ],
    search: "",
    invoices: [],
    subscriberUserData: [],
    stripeSubscription: [],
    stripeSubscriptionDefaultCardId: "",

    //new competitive anaylsis report
    competitiveReportUid: "",

    // loading for the regenerate
    loading: false,

    subscriptionDates: [],

    //paypal subscription
    paypalSubscription: "",
    paypalSubscriptionData: [],
    paypalBillingInfo:[],
    paypalSubscriberInfo:[],
    paypalSubscriberAddress:[],
    paypalSubscriptionDataStatus:"",

    //transactions
    transactionData: [],
  }),
  filters: {
    //formats created Date
    formatDate: function (value) {
      const date = new Date(value);
      return moment(date).format("dddd, MMMM Do YYYY");
    },
    //Gets the next report date
    formatNextDate: function (value) {
      return moment(value).add(30, "days").format("MMMM Do YYYY");
    },
    //Formats invoice amount
    formatCurrency: function (value) {
      const number = Number(value) || 0;
      return (number / 100).toFixed(2);
    },
    //Formats the invoice date
    formatInvoiceDate: function (value) {
      const invoiceDate = new Date(value * 1000); // Convert seconds to milliseconds
      const formattedDate = `${invoiceDate.getDate()} ${invoiceDate.toLocaleString(
        "default",
        { month: "short" }
      )} ${invoiceDate.getFullYear()}, ${invoiceDate.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })}`;
      return formattedDate;
    },
    //format the paypal price 
    formatNumber(value) {
      if (value !== undefined && value !== null) {
        return parseFloat(value).toFixed(2);
      }
      return '';
    },
    daysFromNow(timestamp) {
      if(timestamp){
        const subscriptionDate = moment(timestamp);
        const targetDate = subscriptionDate.add(7, 'days');
        const today = moment();
        return targetDate.diff(today, 'days');
      }else{
        return ''
      }
    }
  },
  computed:{
    daysLeft() {
      const nextBillingTime = moment(this.paypalBillingInfo.next_billing_time);
      const today = moment();
      return nextBillingTime.diff(today, 'days');
    },
    isBillingTabDisabled(item) {
      return (item) => {
        return item.tab === 'Billing Details' && this.packageType === 'Compeat Demo Subscription' || item.tab === 'Billing Details' && this.freeSubscription === true;
      };
    }
  },
  // Gets Current User
  created() {
    this.getSubscriptionInfo();
  },
  methods: {
    billingCycleClass(tenureType) {
      return tenureType === 'TRIAL' ? 'trial-cycle' : 'regular-cycle';
    },
    isExpired(date) {
      if (this.packageType === "Compeat Demo Subscription" && this.$store.state.user.userType != 'SMM') {
      const dateNew = moment(date);
      const targetDate = dateNew.clone().add(7, "days");
      const today = moment();
      const daysLeft = targetDate.diff(today, "days");

      // Disable the button if daysLeft is less than or equal to 0
      return daysLeft <= 0;
    }
  },
    // gets subscription info
    async getSubscriptionInfo() {
      this.overlay = true;
      this.insightsReports = [];
      this.reports = [];
      try {
        const docRef = doc(db, "subscriptions", this.uid); // Use doc() to create a reference to the document
        const docSnapshot = await getDoc(docRef); // Use getDoc() to retrieve the document snapshot
        if (!docSnapshot.exists()) {
          throw new Error("Document not found");
        }
        this.selectedSubscription = docSnapshot.data();
        this.freeSubscription = this.selectedSubscription.freeReport
        console.log("this.selectedSubscription", this.selectedSubscription);
        this.packageType = this.selectedSubscription.package.packageType;
        this.subscriptionDateCreated = this.selectedSubscription.dateCreated;
        this.subscriptionPages = this.selectedSubscription.package.pages;
        this.subscriptionIcon = this.selectedSubscription.package.pages[0].icon;
        this.subscriptionPrimaryPage =
          this.selectedSubscription.package.primaryPage.name;
        this.subscriptionPackage =
          this.selectedSubscription.package.currentPackage;
        this.paypalSubscription =
          this.selectedSubscription.paypalSubscriptionId;

        const competitiveReportIds =
          this.selectedSubscription.reportIds.competitiveReportIds || [];
        const insightsReportIds =
          this.selectedSubscription.reportIds.insightsReportIds || [];
        const instagramReportIds =
          this.selectedSubscription.reportIds.instagramReportIds || [];

        const maxLength = Math.max(
          competitiveReportIds.length,
          insightsReportIds.length,
          instagramReportIds.length
        );

        // Combine the arrays at each index, including the report dates
        const combinedArray = Array.from({ length: maxLength }, (_, index) => {
          const competitiveReportId = competitiveReportIds[index] || null;
          const insightsReportId = insightsReportIds[index] || null;
          const instagramReportId = instagramReportIds[index] || null;

          // Check if competitiveReportId has a date; if not, check insightsReportId
          const date =
            competitiveReportId && competitiveReportId.date
              ? competitiveReportId.date
              : insightsReportId && insightsReportId.date
              ? insightsReportId.date
              : null;

          return {
            competitiveReportId,
            insightsReportId,
            instagramReportId,
            date,
          };
        });

        this.reportSets = combinedArray;

        this.getSubscriber();
      } catch (err) {
        this.overlay = false;
        console.log("err", err);
      }
    },
    // Gets the subscription user
    async getSubscriber() {
      const docRef = doc(db, "users", this.selectedSubscription.subscriberId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        this.subscriberUserData = docSnap.data();
        console.log(
          "this.selectedSubscription.paymentStatus",
          this.selectedSubscription.paypalSubscriptionId
        );
        if (this.selectedSubscription.paypalSubscriptionId) {
          this.getPaypalSubcription();
        } else {
          this.overlay = false;
        }
      } else {
        console.log("No such document!");
        this.overlay = false;
      }
    },
    getPaypalSubcription() {
      console.log('this.paypalSubscription', this.paypalSubscription)
      // paypalSubscription
      const functions = getFunctions(firebaseApp, "europe-west2");
      const getPaypalSubscriptionData = httpsCallable(
        functions,
        "getPaypalSubscriptionData"
      );

      getPaypalSubscriptionData({
        paypalSubscription: this.paypalSubscription,
      }).then((result) => {
        this.paypalSubscriptionData = result.data.response;
        this.paypalSubscriptionDataStatus = this.paypalSubscriptionData.subscriptionData.status
        this.paypalBillingInfo = this.paypalSubscriptionData.subscriptionData.billing_info
        this.paypalSubscriberInfo = this.paypalSubscriptionData.subscriptionData.subscriber
        this.paypalSubscriberAddress = this.paypalSubscriptionData.subscriptionData.subscriber.shipping_address.address

        if(this.paypalSubscriptionData.transactionData){
          this.transactionData = this.paypalSubscriptionData.transactionData;
        }
        console.log("this.paypalSubscriptionData", this.paypalBillingInfo);

        // this.transactionData = this.paypalSubscriptionData.transactionData;

        this.overlay = false;

      });
    },
    approvePayment(){
      console.log('this.paypalSubscriptionData.links[2].href', this.paypalSubscriptionData.subscriptionData.links[2].href)
      this.$store.commit("setCheckOutLink",this.paypalSubscriptionData.subscriptionData.links[2].href);
      window.location.href = this.paypalSubscriptionData.subscriptionData.links[2].href
    },
    successAlert(message, typeOfAlert) {
      this.successResponse = message;
      this.alertType = typeOfAlert;
      this.alert = true;
      setTimeout(() => {
        this.alert = false;
        this.getSubscriptionInfo();
      }, 5000);
    },
    cancelledSubscription(message, typeOfAlert) {
      this.successResponse = message;
      this.alertType = typeOfAlert;
      this.alert = true;
      setTimeout(() => {
        this.alert = false;
        this.$router.push({
          name: "singleCancelledSubscription",
          params: {
            id: this.id,
            uid: this.uid,
          },
        });
      }, 3000);
    },
    pauseSubscription(message, typeOfAlert) {
      this.successResponse = message;
      this.alertType = typeOfAlert;
      this.alert = true;
      setTimeout(() => {
        this.alert = false;
        this.$router.push({
          name: "singlePausedSubscription",
          params: {
            id: this.id,
            uid: this.uid,
          },
        });
      }, 3000);
    },
    checkForPageAccess() {
      const functions = getFunctions(firebaseApp, "europe-west2");
      const getPageToken = httpsCallable(functions, "getPageToken");

      getPageToken({
        userToken: this.subscriberUserData.facebookToken,
        pageId: this.subscriptionPages[0].id,
      }).then((result) => {
        console.log("result getting token", result);
      });
    },
    backToClientSubscriptions() {
      this.$router.push("/");
    },
    backToAgencySubscriptions() {
      this.$router.push("/agency-subscriptions");
    },
    backToAgencyDemoSubscriptions() {
      this.$router.push("/agency-demos");
    },
    backToResellerSubscriptions() {
      this.$router.push("/reseller-subscriptions");
    },
    backToSubscriptions() {
      this.$router.push({
        name: "singleAgency",
        params: {
          id: this.id,
        },
      });
    },
    viewReport(item) {
      // console.log(item)
      this.$router.push({
        name: "singleReport",
        params: {
          id: this.id,
          uid: this.uid,
          reportId: item,
        },
      });
    },
    viewInsightsReport(item) {
      this.$router.push({
        name: "insightsReport",
        params: {
          id: this.id,
          uid: this.uid,
          reportId: item,
        },
      });
    },
    viewInstagramInsightsReport(item) {
      this.$router.push({
        name: "instagramInsightsReport",
        params: {
          id: this.id,
          uid: this.uid,
          reportId: item,
        },
      });
    },
    viewReceipt(item) {
      console.log("viewReceipt", item);
    },
    openUrl(url) {
      console.log(url);
      window.open(url, "_blank");
    },
    // test(){
    //   const functions = getFunctions(firebaseApp, "europe-west2");
    //   const scanSubscriptionsDueTest = httpsCallable(
    //     functions,
    //     "scanSubscriptionsDueTest"
    //   );

    //   scanSubscriptionsDueTest({}).then((result) => {
    //     console.log("this.paypalSubscriptionData", result);

    //   })
    // },
    // async moveDocument() {
    //   try {
    //     // Use doc() to create a reference to the document
    //     const docRef = doc(db, 'subscriptions', '9SGgZc0kftAxHN2EwuB9');
    //     // Use getDoc() to retrieve the document snapshot
    //     const docSnapshot = await getDoc(docRef);

    //     if (!docSnapshot.exists()) {
    //       throw new Error('Document not found');
    //     }

    //     // Create a new document in a different collection
    //     const newData = docSnapshot.data();
    //     const newDocRef = doc(db, 'pausedsubscriptions', '9SGgZc0kftAxHN2EwuB9');
    //     await setDoc(newDocRef, newData);

    //     // Delete the document from the original collection
    //     await deleteDoc(docRef);

    //     console.log('Document moved successfully');
    //   } catch (error) {
    //     console.error('Error moving document:', error);
    //   }
    // }
  },
};
</script>

<style>
.checkaccessbutton {
  display: inline-flex;
}

/* .billingcycle{
  background:#3d6eb1;
  border-radius: 5px 0px 0px 5px
} */

.trial-cycle {
  background: #eb1e77 !important; /* Set the color for trial */
  border-radius: 5px 0px 0px 5px
}

.regular-cycle {
  background: #3d6eb1 !important; /* Set the color for regular */
  border-radius: 5px 0px 0px 5px
}
</style>
